import { OptionType } from 'components';

// Define enum for nationality options

export enum Nationality {
    Select = '0',
    NotSpecified = '1',
    France = '2',
    OtherCountries = '4',
    EuropeanUnion = '5',
}
// Array of nationality options

export const optionNationality: OptionType[] = [
    { value: Nationality.NotSpecified, label: 'Non précisé' },
    { value: Nationality.France, label: 'France' },
    { value: Nationality.OtherCountries, label: 'Autres pays étrangers' },
    { value: Nationality.EuropeanUnion, label: 'Union Européenne' },
]; //////////////////////////////
export enum Gender {
    Homme = '1',
    Femme = '2',
}
export const genderOptions: OptionType[] = [
    { value: Gender.Homme, label: 'workStopping.values.male' },
    { value: Gender.Femme, label: 'workStopping.values.female' },
];
export enum Regime {
    General = '1',
    AlsaceMoselle = '2',
}

export const regimeOptions: OptionType[] = [
    { value: Regime.General, label: 'Général' },
    { value: Regime.AlsaceMoselle, label: 'Alsace-Moselle' },
];
export const getOptionRegimeLabelByValue = (value: Regime): string | undefined => {
    const option = regimeOptions.find((option) => option.value === value);
    return option ? option.label.toString() : undefined;
};

export enum SituationFamille {
    Marie = 'm',
    Celibataire = 'c',
    Divorce = 'd',
    Pacse = 'p',
    Concubinage = 'co',
}

export const situationFamilleOptions: OptionType[] = [
    { value: SituationFamille.Marie, label: 'Marié(e)' },
    { value: SituationFamille.Celibataire, label: 'Célibataire' },
    { value: SituationFamille.Divorce, label: 'Divorcé(e)' },
    { value: SituationFamille.Pacse, label: 'Pacsé(e)' },
    { value: SituationFamille.Concubinage, label: 'Concubinage' },
];
export enum Csp {
    AuthorArtists = 'AAA',
    SeasonalActivity = 'ADI',
    ArtistsMusiciansModels = 'AMM',
    Apprentices = 'APP',
    VoluntaryInsured = 'AVO',
    CaretakersChildminders = 'CAM',
    SpecialCase = 'CAS',
    NotaryClerks = 'CEN',
    BranchManagers = 'GSM',
    SandwichMenDockers = 'HSD',
    Journalists = 'JRN',
    Negotiators = 'NEG',
    MedicalPractitioners = 'PAM',
    AssistedPersons = 'PAS',
    ProfessionalTrainees = 'SFP',
    StandardCase = 'STD',
    HomeWorkers = 'TAD',
    TemporaryWorkers = 'TRI',
    Demonstrator = 'VRP',
}

export const cspOptions: OptionType[] = [
    { value: Csp.StandardCase, label: 'Cas standard (salarié mensualisé)' },
    { value: Csp.SpecialCase, label: 'Cas particulier' },
    { value: Csp.SeasonalActivity, label: 'Activité saisonnière continue ou discontinue' },
    { value: Csp.Apprentices, label: 'Apprentis' },
    { value: Csp.ArtistsMusiciansModels, label: 'Artistes / Musiciens / Mannequins' },
    { value: Csp.AuthorArtists, label: 'Artistes auteurs' },
    { value: Csp.VoluntaryInsured, label: 'Assurés volontaires' },
    { value: Csp.NotaryClerks, label: 'Clercs de notaire' },
    { value: Csp.CaretakersChildminders, label: 'Concierges / Assistantes maternelles' },
    { value: Csp.Demonstrator, label: 'Démonstrateur' },
    { value: Csp.BranchManagers, label: 'Gérant de succursales multiples' },
    { value: Csp.SandwichMenDockers, label: 'Hommes sandwiches / Dockers' },
    { value: Csp.Journalists, label: 'Journalistes' },
    { value: Csp.Negotiators, label: 'Négociateurs' },
    { value: Csp.AssistedPersons, label: 'Personnes assistées' },
    { value: Csp.MedicalPractitioners, label: 'Praticiens Auxiliaires Médicaux' },
    { value: Csp.ProfessionalTrainees, label: 'Stagiaires formation professionnelle' },
    { value: Csp.HomeWorkers, label: 'Travailleurs à domicile' },
    { value: Csp.TemporaryWorkers, label: 'Travailleurs intérimaires' },
];

export enum JobStatus {
    NonCadre = 'nc',
    Cadre = 'c',
}

export const categoryOptions: OptionType[] = [
    { value: JobStatus.NonCadre, label: 'Non cadre' },
    { value: JobStatus.Cadre, label: 'Cadre' },
];
